import { faCircleNotch } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Typography } from "@mui/material"
import { useApi } from "auth/useApi3"
import { StandardButton } from "components/Button"
import PaperCard from "components/PaperCard"
import React from "react"
import { useTranslation } from "react-i18next"

export const PasswordSuggestion = ({ values, setFieldValue, passwordSuggestEndpoint }) => {
  const [newPasswordResult, newPasswordApi] = useApi()
  const { t } = useTranslation()

  React.useEffect(async () => {
    await newPasswordApi.get(passwordSuggestEndpoint)
  }, [])

  React.useEffect(() => {
    if (newPasswordResult.status === 2) {
      setFieldValue("password", newPasswordResult.data)
    }
  }, [newPasswordResult])

  return (
    <PaperCard>
      <Box mb={2}>
        <Typography>{t("global.random_password", "Randomly generated password:")}</Typography>
      </Box>
      <Typography variant="h5" on>
        {values.password}
      </Typography>
      <Box mt={2} mb={2}>
        <StandardButton
          color="primary"
          startIcon={<FontAwesomeIcon spin={newPasswordResult.status === 1} icon={faCircleNotch} />}
          onClick={() => {
            newPasswordApi.get(passwordSuggestEndpoint)
          }}>
          {t("global.generate_new_password", "Generate new password")}
        </StandardButton>
      </Box>
      <Typography>
        {t(
          "settings.user.write_down_this_password",
          "Write down this password and give it to the user. If the password seems too complicated, try generating a new one at random."
        )}
      </Typography>
    </PaperCard>
  )
}
